import React, { useState } from "react";
import { File } from "lucide-react";

const LocationSection = ({ formData, setFormData }) => {
  const [kmlFile, setKmlFile] = useState(null);
  const [locationDetails, setLocationDetails] = useState([]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData("projectLocation", {
      ...formData.projectLocation,
      [name]: value,
    });
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file && file.name.endsWith(".kml")) {
      if (file.size > 5 * 1024 * 1024) {
        // 5MB limit
        alert("File size should not exceed 5MB");
        return;
      }
      setKmlFile(file);
      setFormData("projectLocation", {
        ...formData.projectLocation,
        kmlFile: file,
      });
      // Simulating KML file parsing
      // In a real application, you would parse the KML file here
      setLocationDetails([
        {
          toposheet: "F43O13",
          state: "MADHYA PRADESH",
          district: "Barwani",
          subDistrict: "Rajpur",
          village: "REVJA",
          plotNo: "547/1/1, 547/2",
        },
      ]);
    } else {
      alert("Please upload a valid KML file");
    }
  };

  const handleFileRemove = () => {
    setKmlFile(null);
  };

  const addNewRow = (e) => {
    e.preventDefault();
    setLocationDetails([
      ...locationDetails,
      {
        toposheet: "",
        state: "",
        district: "",
        subDistrict: "",
        village: "",
        plotNo: "",
      },
    ]);
  };

  const removeLastRow = (e) => {
    e.preventDefault();
    if (locationDetails.length > 1) {
      setLocationDetails(locationDetails.slice(0, -1));
    }
  };

  const handleLocationChange = (index, field, value) => {
    const updatedLocations = locationDetails.map((location, i) => {
      if (i === index) {
        return { ...location, [field]: value };
      }
      return location;
    });
    setLocationDetails(updatedLocations);
  };

  return (
    <>
      <div className="form-section">
        <div className="section-header">
          <h2>Location of the Project or Activity</h2>
        </div>
        <div className="form-group upload-section">
          <label className="required">Upload KML</label>
          <div className="upload-container">
            <div className="upload-area">
              {!kmlFile ? (
                <label className="file-input-label">
                  <input
                    type="file"
                    accept=".kml"
                    name="kmlFile"
                    onChange={handleFileUpload}
                    className="file-input"
                  />
                  <div className="upload-placeholder">
                    <File />
                    <p>Click to upload KML file</p>
                  </div>
                </label>
              ) : (
                <div className="file-preview">
                  <File />
                  <span className="file-name">{kmlFile.name}</span>
                  <button className="remove-file" onClick={handleFileRemove}>
                    ×
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="form-group">
          <label className="required">
            Whether the project/activity falling in the state/UT sharing
            international borders
          </label>
          <select
            name="internationalBorder"
            value={formData.projectLocation.internationalBorder}
            onChange={handleInputChange}
            required
          >
            <option value="">Select</option>
            <option value="yes">Yes</option>
            <option value="no">No</option>
          </select>
        </div>

        <div className="form-group">
          <label className="required">Shape of the Project</label>
          <select
            name="projectShape"
            value={formData.projectLocation.projectShape}
            onChange={handleInputChange}
            required
          >
            <option value="">Select</option>
            <option value="hybrid">Hybrid</option>
            <option value="linear">Linear</option>
            <option value="non-linear">Non - Linear</option>
          </select>
        </div>

        {locationDetails && locationDetails.length > 0 && (
          <div className="location-details">
            <h3>Location Details</h3>
            <div className="location-table">
              <table>
                <thead>
                  <tr>
                    <th>Toposheet No</th>
                    <th>State/UT</th>
                    <th>District</th>
                    <th>Sub District</th>
                    <th>Village</th>
                    <th>Plot/Survey/Khasra No.</th>
                  </tr>
                </thead>
                <tbody>
                  {locationDetails.map((location, index) => (
                    <tr key={index}>
                      <td>
                        <input
                          type="text"
                          value={location.toposheet}
                          onChange={(e) =>
                            handleLocationChange(
                              index,
                              "toposheet",
                              e.target.value
                            )
                          }
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          value={location.state}
                          onChange={(e) =>
                            handleLocationChange(index, "state", e.target.value)
                          }
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          value={location.district}
                          onChange={(e) =>
                            handleLocationChange(
                              index,
                              "district",
                              e.target.value
                            )
                          }
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          value={location.subDistrict}
                          onChange={(e) =>
                            handleLocationChange(
                              index,
                              "subDistrict",
                              e.target.value
                            )
                          }
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          value={location.village}
                          onChange={(e) =>
                            handleLocationChange(
                              index,
                              "village",
                              e.target.value
                            )
                          }
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          value={location.plotNo}
                          onChange={(e) =>
                            handleLocationChange(
                              index,
                              "plotNo",
                              e.target.value
                            )
                          }
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="table-buttons">
                <button className="add-row-button" onClick={addNewRow}>
                  Add Row
                </button>
                <button
                  className="remove-row-button"
                  onClick={removeLastRow}
                  disabled={locationDetails.length <= 1}
                  style={{
                    backgroundColor:
                      locationDetails.length <= 1 ? "#cccccc" : "#ff4444",
                    cursor:
                      locationDetails.length <= 1 ? "not-allowed" : "pointer",
                  }}
                >
                  Remove Last Row
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="form-section">
        <h3>
          Land Requirement <i>{"(in Ha)"}</i> of the Project or Activity
        </h3>
        <h4>Nature of the Land involved</h4>
        <div className="form-group">
          <label className="required">Non-Forest Land {"(A)"}</label>
          <input
            type="text"
            name="nonForestLand"
            value={formData.projectLocation.nonForestLand}
            onChange={handleInputChange}
            placeholder="Non-Forest Land"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Forest Land {"(B)"}</label>
          <input
            type="text"
            name="forestLand"
            value={formData.projectLocation.forestLand}
            onChange={handleInputChange}
            placeholder="Forest Land"
            required
          />
        </div>
        <div className="form-group">
          <label>Total Land {"(A+B)"}</label>
          <input
            type="text"
            name="totalLand"
            value={formData.projectLocation.totalLand}
            onChange={handleInputChange}
            placeholder="Total Land"
          />
        </div>
      </div>
    </>
  );
};

export default LocationSection;
